import { render, staticRenderFns } from "./ListParametroRelatorioView.vue?vue&type=template&id=d1062912&"
import script from "./ListParametroRelatorioView.vue?vue&type=script&lang=ts&"
export * from "./ListParametroRelatorioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports